const getPageNumbers = (currentPage, totalPages) => {
  const pages = [];
  const delta = 2; // jumlah halaman kiri & kanan yang ditampilkan

  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 || // selalu tampil halaman pertama
      i === totalPages || // selalu tampil halaman terakhir
      (i >= currentPage - delta && i <= currentPage + delta)
    ) {
      pages.push(i);
    } else if (
      (i === currentPage - delta - 1 && currentPage - delta > 2) ||
      (i === currentPage + delta + 1 && currentPage + delta < totalPages - 1)
    ) {
      pages.push('...');
    }
  }

  return pages;
};

export default getPageNumbers;
